export default {
  id: 'contracts',
  title: 'Contracts',
  category: 'Admin',
  summary: 'Manage customer contracts, periods of performance, labor rates, fee basis, funding obligations, and related projects.',
  overview: 'A contract defines the commercial agreement with a customer. Projects, rates, funding, and invoices roll up under it. Time & Material contracts use Labor Categories / Labor Rates. Cost-based (cost-plus) contracts use Direct Labor Rates, Fee Basis, and Contract Funding obligations instead of classic T&M labor rates.',
  howItWorks: [
    'Contracts belong to a customer and contain one or more projects (task orders).',
    'Periods of performance (POPs) define when work is authorized.',
    'On T&M contracts, Labor Categories and Labor Rates drive how billable time is priced.',
    'On cost-based contracts, Direct Labor Rates combine employee compensation with indirect rates; Fee Basis defines fee structure (WDLR, fully loaded, fee/hr, max rate) by POP and labor category.',
    'Contract Funding (cost-based primes) captures customer obligations (CLIN/SLIN/ACRN) that projects attribute to Labor and Fee line items.',
    'Direct Labor Rate mismatch scanning flags employees whose compensation no longer matches an active rate / charge code so you can fix them.',
    'Documents, subcontractors, and invoices can also be associated at the contract level.'
  ],
  actions: [
    {
      name: 'Create / edit contract',
      description: 'Adds or updates identifying information, contract class/type, and commercial settings. Cost-based vs T&M changes which rate and funding tabs appear.'
    },
    {
      name: 'Manage POPs',
      description: 'Maintains periods of performance used by rates, fee basis, and funding.'
    },
    {
      name: 'Direct Labor Rates (cost-based)',
      description: 'Create or edit rates tied to employees, charge codes, indirect rate tables, and fee basis. Optional mismatch scan/fix keeps rates aligned with compensation.'
    },
    {
      name: 'Labor Rates (T&M)',
      description: 'Maintain billable labor category rates used when invoicing approved time on non–cost-based contracts.'
    },
    {
      name: 'Fee Basis (cost-based)',
      description: 'Add an initial fee basis or modifications per POP / labor category. Rows that have already been invoiced may be locked from certain edits.'
    },
    {
      name: 'Contract Funding (cost-based)',
      description: 'Add or bulk-import funding obligations. See the Funding Obligations help topic for the full contract → project workflow.'
    }
  ],
  tips: [
    'For cost-plus work: configure Indirect Rates (Settings), Direct Labor Rates, and Fee Basis before funding projects or invoicing.',
    'Use Bulk Import on Contract Funding for many CLIN/ACRN lines; download the template first.',
    'Resolve Direct Labor Rate mismatches before employees charge time you intend to invoice at cost.'
  ],
  related: ['customers', 'projects', 'funding-obligations', 'invoices', 'settings']
};



// WEBPACK FOOTER //
// ./client/help/content/contracts.js